<template>
  <div class="optinconfirmed">
    <img
      v-if="hasValidLogo"
      :src="logo"
      alt="Logo"
      class="logo">
    <h1><span v-t="'optinconfirmed.title'" /></h1>
    <p class="text-soft">
      {{ $t('optinconfirmed.legend') }}
    </p>
    <div class="buttons btn-confirmed">
      <a
        v-if="url"
        v-t="'optinconfirmed.action'"
        class="btn primary"
        :href="url" />
    </div>
  </div>
</template>

<script>
import hasLogo from '@/mixins/hasLogo';

export default {
  mixins: [hasLogo],
  data() {
    return {
      url: null,
      account: null,
    };
  },
  created() {
    document.title = this.$t('optinconfirmed.pageTitle');
    this.account = this.$route.query.account;

    if (this.account) {
      this.preloadLogo();
    }

    try {
      // eslint-disable-next-line
      new URL(this.$route.query.url);
      this.url = this.$route.query.url;
    } catch (e) {
      this.url = null;
    }
  },
};

</script>
